import { first } from "lodash";

function pdpOfferTimer(isQuickview = false) {
	let countdownTo = $(`.pdpTimerCountdownTo${isQuickview?'.quickview-timer':''}`).first().val();
	if (!countdownTo || !(countdownTo.length)){
		$(`${isQuickview?'.quickview__dialog ':''}.pdp__timer`).hide();
		return;
	} 
	let intrvl = setInterval(() => {
		let now = new Date().getTime();
		countdownTo = new Date(countdownTo).getTime();
		let counterStart = countdownTo - now;
		let timeEntries = $(`${isQuickview?'.quickview__dialog ':''}.pdp__timer-countdown-item--number`);
		if(counterStart <= 0){
			$(`${isQuickview?'.quickview__dialog ':''}.pdp__timer`).hide();
			return;
		}

		if (counterStart < 0) {
			timeEntries.each(function(index) {
				$(this).html('00');
			});
			clearInterval(intrvl);
		} else {
			let days = Math.floor(counterStart / (1000 * 60 * 60 * 24));
			let hrs = Math.floor((counterStart % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			let mins = Math.floor((counterStart % (1000 * 60 * 60)) / (1000 * 60));
			let secs = Math.floor((counterStart % (1000 * 60)) / 1000);

			let timer = [days, hrs, mins, secs];
			timer = timer.map(num => {
				return num.toLocaleString('en-US', {
					minimumIntegerDigits: 2,
					useGrouping: false
				});
			});
			let length = timer.length; 
			timeEntries.each(function(index) {
				if (index < length) {
					$(this).html(timer[index]);
				} else {
					$(this).html(timer[index-length]);
				}
			});
		}
	}, 1000);
}


function categoryOfferTimer() {
	let countdownTo = $(`.plpTimerCountdownTo`).first().val();
	if (!countdownTo || !(countdownTo.length)){
		$(`.plp__offer__timer`).hide();
		return;
	}
	let intrvl = setInterval(() => {
		let now = new Date().getTime();
		countdownTo = new Date(countdownTo).getTime();
		let counterStart = countdownTo - now;
		let timeEntries = $(`.plp__offer__timer-countdown-item--number`);
		if(counterStart <= 0){
			$(`.plp__offer__timer`).hide();
			return;
		}

		if (counterStart < 0) {
			timeEntries.each(function(index) {
				$(this).html('00');
			});
			clearInterval(intrvl);
		} else {
			let days = Math.floor(counterStart / (1000 * 60 * 60 * 24));
			let hrs = Math.floor((counterStart % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			let mins = Math.floor((counterStart % (1000 * 60 * 60)) / (1000 * 60));
			let secs = Math.floor((counterStart % (1000 * 60)) / 1000);

			let timer = [days, hrs, mins, secs];
			timer = timer.map(num => {
				return num.toLocaleString('en-US', {
					minimumIntegerDigits: 2,
					useGrouping: false
				});
			});

			timeEntries.each(function(index) {
				$(this).html(timer[index]);
			});
		}
	}, 1000);
}

exports.pdpOfferTimer=pdpOfferTimer;
exports.categoryOfferTimer=categoryOfferTimer;


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/offertimer.js